import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../actions/searchActions";
import {
  Button,
  Form,
  Container,
  Row,
  Col,
  Media,
  UncontrolledTooltip
} from "reactstrap";
import { joinCss } from "../helpers/utils";
import ChaptersSort from "./ChaptersSort";
import DatesSort from "./DatesSort";
import SearchAutoComplete from "./SearchAutoComplete";

import searchHeaderImage from "../images/searchHeaderImage.png";
import searchHeaderImageMobile from "../images/viewHeaderMobile.png";
import search from "../images/searchHome.png";
import info from "../images/info.png";

import appClasses from "../App.module.scss";
import classes from "./Header.module.scss";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //searchTerm: "",
      searchTerm: this.props.searchTerm,
      totalResults: this.props.totalResults,
      mdMode: false
      //showSpinner: false
    };
  }

  updateDimensions() {
    if (window.innerWidth <= 992 || window.screen.width <= 992) {
      this.setState({ mdMode: true });
    } else {
      this.setState({ mdMode: false });
    }
  }

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions.bind(this));
  }

  onKeyPressed(event, handler) {
    if (event.charCode === 13) {
      //enter was pressed
      event.preventDefault();
      handler();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.searchTerm) {
      this.setState({ searchTerm: nextProps.searchTerm });
    }
    this.setState({ totalResults: nextProps.totalResults });
  }

  render() {
    const datesTooltip = (
      <UncontrolledTooltip
        placement="left-end"
        target="datesInfo"
        innerClassName={classes.tooltipInner}
      >
        בחירת תאריך - ניתן לבחור את מועד המכרז או לבחור לחפש מידע בכל ההמהדורות
        ודפי התיקון באתר. במידה והוזן מועד המכרז, המערכת תבצע את החיפוש רק
        בפרקים ובדפי התיקון האחרונים הרלוונטיים לאותו מועד.
      </UncontrolledTooltip>
    );
    const chaptersTooltip = (
      <UncontrolledTooltip
        placement="left-end"
        target="chaptersInfo"
        innerClassName={classes.tooltipInner}
      >
        רשימת הפרקים הרלוונטים לחיפוש שבוצע.
      </UncontrolledTooltip>
    );
    return (
      <Container>
        <Row>
          <Col sm="12" className="px-0">
            <Media heading>
              <Media
                src={
                  this.state.mdMode
                    ? searchHeaderImageMobile
                    : searchHeaderImage
                }
                alt="תמונה כללית"
                className={classes.headerImage}
              />
            </Media>
            <Container className={joinCss("mt-2", classes.headerContainer)}>
              <Row>
                <Col md="0" lg="1" />
                <Col
                  xl="2"
                  lg="3"
                  md="12"
                  className={joinCss(
                    classes.headerTitle,
                    appClasses["right-align-div"]
                  )}
                >
                  {this.state.mdMode ? (
                    <div>תוצאות חיפוש</div>
                  ) : (
                    <div>
                      <div>תוצאות</div>
                      <div>חיפוש</div>
                    </div>
                  )}
                </Col>
                <Col xl="8" lg="7" md="12" className={classes.formCol}>
                  <Form
                    className={joinCss(classes.searchForm)}
                    onKeyPress={e =>
                      this.onKeyPressed(e, this.props.clearAndSearchHandler)
                    }
                  >
                    <Row form>
                      <Col
                        sm="12"
                        className={joinCss(classes.searchFieldCol, "pr-1")}
                      >
                        <SearchAutoComplete />
                        <Button
                          link
                          className={classes.searchButton}
                          onClick={this.props.clearAndSearchHandler}
                        >
                          <Media
                            src={search}
                            alt="חפש"
                            className={classes.searchImg}
                          />
                        </Button>
                      </Col>
                    </Row>
                    {this.state.totalResults > 0 ? (
                      this.state.mdMode ? (
                        <div>
                          <Row className="pb-3 pr-2">
                            <Col className={joinCss(classes.sortLabel, "pb-3")}>
                              סינון תוצאות לפי:
                            </Col>
                          </Row>
                          <Row form className={classes.sortButtonsRow}>
                            <Col
                              sm="6"
                              className={joinCss("pr-3", classes.sortLabeCol)}
                            >
                              פרקים עדכניים לתאריך
                              <Media
                                id="datesInfo"
                                className={classes.infoImg}
                                src={info}
                                alt="מידע"
                              />
                              {datesTooltip}
                            </Col>
                            <Col sm="6" className="pr-3">
                              <DatesSort />
                            </Col>
                          </Row>
                          <Row form className={classes.sortButtonsRow}>
                            <Col
                              sm="6"
                              className={joinCss("pr-3", classes.sortLabeCol)}
                            >
                              פרק
                              <Media
                                id="chaptersInfo"
                                className={classes.infoImg}
                                src={info}
                                alt="מידע"
                              />
                              {chaptersTooltip}
                            </Col>
                            <Col sm="6" className="pr-3">
                              <ChaptersSort />
                            </Col>
                          </Row>
                        </div>
                      ) : (
                        <div>
                          <Row
                            className={joinCss(
                              classes.labelRow,
                              "pt-3",
                              "pb-2"
                            )}
                          >
                            <Col sm="2" />
                            <Col sm="5" className={classes.labelCol}>
                              פרקים עדכניים לתאריך
                              <Media
                                id="datesInfo"
                                className={classes.infoImg}
                                src={info}
                                alt="מידע"
                              />
                              {datesTooltip}
                            </Col>
                            <Col sm="5" className={classes.labelCol}>
                              פרק
                              <Media
                                id="chaptersInfo"
                                className={classes.infoImg}
                                src={info}
                                alt="מידע"
                              />
                              {chaptersTooltip}
                            </Col>
                          </Row>
                          <Row form className={classes.sortButtonsRow}>
                            <Col
                              sm="2"
                              className={joinCss(classes.sortLabel, "pr-3")}
                            >
                              סינון תוצאות לפי:
                            </Col>
                            <Col sm="5" className="px-0">
                              <DatesSort />
                            </Col>
                            <Col sm="5" className="px-0">
                              <ChaptersSort />
                            </Col>
                          </Row>
                        </div>
                      )
                    ) : (
                      ""
                    )}
                  </Form>
                </Col>
                <Col md="0" lg="1" />
              </Row>
            </Container>
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    searchTerm: state.searchData.searchTerm,
    totalResults: state.searchData.totalResults
  };
};

const mapDispatchToProps = dispatch => {
  return {
    searchHandler: () => dispatch(actions.search()),
    clearAndSearchHandler: () => dispatch(actions.clearDataAndSearch()),
    termChangeHandler: value => dispatch(actions.setTerm(value))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
